import { render, staticRenderFns } from "./OrgContactInfo.vue?vue&type=template&id=756a5adc&scoped=true&"
import script from "./OrgContactInfo.vue?vue&type=script&lang=js&"
export * from "./OrgContactInfo.vue?vue&type=script&lang=js&"
import style0 from "./OrgContactInfo.vue?vue&type=style&index=0&id=756a5adc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "756a5adc",
  null
  
)

export default component.exports